// this is just better for performance if only in-view autoplaying videos play

// note to self: i do not add "autoplay" attribute to carousel videos but i just play and pause them using custom code in carousel addon
// so the following code is not for videos in carousels
var videoList
var infos = []
var isAnyVideoFullscreen = false

var getVideoReferences = function () {
	// Get autoplay videos (original selector)
	const autoplayVideos = document.querySelectorAll('video.autoplay[playsinline][muted]')
	// Get videos with custom controls that also have autoplay
	const customControlAutoplayVideos = document.querySelectorAll('.html5video.lay-vimeo-custom-controls video.autoplay[playsinline][muted]')
	
	// Combine both lists and remove duplicates
	const allVideos = new Set([...autoplayVideos, ...customControlAutoplayVideos])
	videoList = Array.from(allVideos)
	
	// Add fullscreen event listeners for iOS
	videoList.forEach((video) => {
		// iOS fullscreen events
		video.addEventListener('webkitbeginfullscreen', function() {
			isAnyVideoFullscreen = true
		})
		video.addEventListener('webkitendfullscreen', function() {
			isAnyVideoFullscreen = false
		})
		// Standard fullscreen events
		video.addEventListener('fullscreenchange', function() {
			isAnyVideoFullscreen = !!document.fullscreenElement
		})
		video.addEventListener('webkitfullscreenchange', function() {
			isAnyVideoFullscreen = !!(document.webkitFullscreenElement || document.fullscreenElement)
		})
	})
	
	// Add orientation change listener to check fullscreen state on iOS
	// Sometimes rotation doesn't fire webkitendfullscreen properly
	window.addEventListener('orientationchange', function() {
		// Check all videos to see if any are actually in fullscreen
		let anyInFullscreen = false
		videoList.forEach((video) => {
			if (video.webkitDisplayingFullscreen) {
				anyInFullscreen = true
			}
		})
		isAnyVideoFullscreen = anyInFullscreen
	})
	
	initInfos()
	initObserve()
}

// need variables for playing and playpromise to know if i can pause a video or play it
// https://developers.google.com/web/updates/2017/06/play-request-was-interrupted
var initInfos = function () {
	infos = []
	videoList.forEach((video, i) => {
		infos[i] = {
			playing: false,
			playPromise: null,
		}
	})
}

window.laytheme.on('content_ready', function () {
	getVideoReferences()
	initObserve()
})

var callback = (entries, observer) => {
	// Don't do anything if we're in fullscreen mode, otherwise this may pause the current video and play other videos
	if (isAnyVideoFullscreen) {
		return
	}
	
	entries.forEach((entry) => {
		// Each entry describes an intersection change for one observed
		var ix = Array.from(videoList).indexOf(entry.target)
		if (entry.isIntersecting) {
			// checking for && !this.ended to not replay a video that has already ended and that is not loop="true"
			// only play video if user hasn't paused it or if data-dirty is not "true"
			const isDirty = entry.target.dataset.dirty === 'true'
			if (typeof infos[ix] != undefined && infos[ix]['playing'] == false && !entry.target.ended && !jQuery(entry.target).hasClass('userinteractedwith-paused') && !isDirty) {
				try {
					// if( entry.target.readyState )
					if (entry.target.readyState >= 2) {
						infos[ix]['playPromise'] = entry.target.play()
						if(infos[ix]['playPromise']) {
							infos[ix]['playPromise'].then(function () {
								infos[ix]['playing'] = true
							})
						}
					} else {
						;(function (ix) {
							entry.target.addEventListener('canplay', (event) => {
								if (typeof infos[ix] != undefined) {
									infos[ix]['playPromise'] = entry.target.play()
									infos[ix]['playPromise'].then(function () {
										infos[ix]['playing'] = true
									})
								}
							})
						})(ix)
					}
				} catch (err) {}
			}
		} else {
			if (typeof infos[ix] != undefined && infos[ix] && infos[ix]['playing'] != undefined && infos[ix]['playing'] == true) {
				entry.target.pause()
				infos[ix]['playing'] = false
			}
		}
	})
}

var initObserve = function () {
	if ('IntersectionObserver' in window) {
		let observer = new IntersectionObserver(callback)
		// observe elements
		videoList.forEach((video) => {
			observer.observe(video)
		})
	}
}

var play_pause_autoplay_videos_on_scroll_controller = {
	// seems like this function is called nowhere outside
	getVideoReferences: function () {
		getVideoReferences()
	},
}

export { play_pause_autoplay_videos_on_scroll_controller }
